module.exports = __webpack_public_path__ + "media/images/faces/male/28-020f97461d5d8eb80bcb8e2b72c03dc5.jpg";